import { render, staticRenderFns } from "./ContactsComponents.vue?vue&type=template&id=3f0ae57d&"
import script from "./ContactsComponents.vue?vue&type=script&lang=js&"
export * from "./ContactsComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports